import axios from "axios";
import axiosInstance, { BASE_URL } from "../helper/apiConfig";
import Cookies from "js-cookie";

export const login = async (formData, callback) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/login`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    callback(response.data);
  } catch (error) {
    callback(
      error.response?.data || { success: false, message: "Network error" }
    );
  }
};

export const refresh_token = async (formData, callback) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/refresh`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    callback(response.data);
  } catch (error) {
    callback(
      error.response?.data || { success: false, message: "Network error" }
    );
  }
};

// 🔵 GET EMPLOYEE DETAILS: Now much cleaner!
export const getEmployeeDetails = async () => {
  try {
    // The axiosInstance automatically handles the Token and Refreshing!
    const response = await axiosInstance.get(`/auth/employee_details`);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Return error data safely
    throw error.response?.data || { message: "Network error" };
  }
};

export const logout = async () => {
  try {
    // axiosInstance automatically attaches the token and handles the Base URL
    const response = await axiosInstance.post(`/auth/logout`);

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const forgotPassword = async (userData, callback) => {
  try {
    const response = await axiosInstance.post(
      `/reset/forgot-password`,
      JSON.stringify(userData), // Keep this if your backend specifically needs a JSON string
      {
        headers: {
          "Content-Type": "application/json",

        },
      }
    );
    callback(response.data);
  } catch (error) {
    callback(
      error.response?.data || { success: false, message: "Network error" }
    );
  }
};

export const resetPassword = async (userData, callback) => {
  try {
    const response = await axiosInstance.post(
      `/reset/reset-password`,
      JSON.stringify(userData),
      {
        headers: {
          "Content-Type": "application/json",
          // Accept header is usually handled by the instance, but no harm keeping it if you want
          Accept: "application/json",
        },
      }
    );
    callback(response.data);
  } catch (error) {
    callback(
      error.response?.data || { success: false, message: "Network error" }
    );
  }
};

export const changePassword = async (userData) => {
  try {
    // axiosInstance handles the Base URL and attaches the Access Token automatically
    const response = await axiosInstance.post(
      `/reset/change-password`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getMenus = async () => {
  try {

    const response = await axiosInstance.get(`/menus/get-menu`);

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const addpostbasedonhrms = async (formData) => {
  try {
    // axiosInstance automatically handles the token and detects FormData headers
    const response = await axiosInstance.post(
      `/company_updates/company-update`,
      formData
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || new Error("Network error");
  }
};

export const getAllPostsWithPagination = async (params = {}) => {
  try {
    // axiosInstance handles tokens, Base URL, and automatically converts 'params' to a query string
    const response = await axiosInstance.get(`/company_updates/get_all_posts_with_pagination`, {
      params: params,
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const reactToPost = async (userData) => {
  try {
    // axiosInstance automatically handles the token, Base URL, and JSON content type
    const response = await axiosInstance.post(
      `/company_updates/react_to_post`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const commentOnPost = async (userData) => {
  try {
    // axiosInstance handles the token, headers, and Base URL automatically
    const response = await axiosInstance.post(
      `/company_updates/add_comments_to_post`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getPendingPosts = async (params = {}) => {
  try {
    // axiosInstance automatically handles the token, Base URL, 
    // and converts the 'params' object into a query string (e.g., ?page=1&page_size=10)
    const response = await axiosInstance.get(`/posts/pending-posts`, {
      params: params,
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const approveRejectPost = async (userData) => {
  try {
    // axiosInstance automatically handles the token, Base URL, and JSON headers
    const response = await axiosInstance.post(
      `/posts/approve-reject-post`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const addComments = async (userData) => {
  try {
    // axiosInstance handles the token, Base URL, and headers automatically
    const response = await axiosInstance.post(
      `/predefined-comments/create-new-comment`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAllComments = async () => {
  try {
    // axiosInstance automatically handles the token, headers, and Base URL
    const response = await axiosInstance.get(`/predefined-comments/get-all-comments`);

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const deleteComments = async (userData) => {
  try {
    // axiosInstance handles the token, Base URL, and JSON headers automatically
    const response = await axiosInstance.post(
      `/predefined-comments/delete`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAllPosts = async (params = {}) => {
  try {

    // and converts the 'params' object into a query string (e.g., ?page=1&page_size=10)
    const response = await axiosInstance.get(`/posts/get-all-posts`, {
      params: params,
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const deleteSinglePosts = async (userData) => {
  try {
    // axiosInstance automatically handles the token, Base URL, and JSON content type
    const response = await axiosInstance.post(
      `/posts/delete-post`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const recentEmployees = async () => {
  try {
    // axiosInstance automatically handles the token, headers, and Base URL
    const response = await axiosInstance.get(`/onboard/recent-onboarded-employees`);

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getComments = async (params = {}) => {
  try {

    // and converts the 'params' object into a query string (e.g., ?type=something)
    const response = await axiosInstance.get(`/predefined-comments/get-comments`, {
      params: params,
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const sendWishes = async (userData) => {
  try {

    const response = await axiosInstance.post(
      `/predefined-comments/send-wishes`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getPostLikeHistory = async (params = {}) => {
  try {

    // and converts the 'params' object into a query string (e.g., ?posts_id=123)
    const response = await axiosInstance.get(`/company_updates/get_posts_reaction_details`, {
      params: params,
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const viewPostStart = async (userData) => {
  try {
    // axiosInstance automatically handles the token, Base URL, and headers
    const response = await axiosInstance.post(
      `/company_updates/view-posts-start`,
      userData
    );

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const viewPostEnd = async (userData) => {
  try {
    const accessToken = Cookies.get("access_token");
    if (!accessToken) {
      throw new Error("Access token not found");
    }

    const url = `${BASE_URL}/company_updates/view-posts-end`;

    const response = await axios.post(url, userData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAllMenuItems = async (params = {}) => {
  try {
    // axiosInstance handles token, BASE_URL, and query params automatically
    const response = await axiosInstance.get(`/menus/get-all-menu-items`, {
      params: params, // Automatically converts {page: 1, search_query: 'abc'} into query string
    });

    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getMenuUpdate = async (userData) => {
  try {
    const response = await axiosInstance.post(`/menus/update-menu-items`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getPostViewDetails = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/company_updates/get_posts_views_details`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const addMenuUsage = async (userData) => {
  try {
    const response = await axiosInstance.post(`/menus/add-menu-usage-count`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const createMenuItem = async (userData) => {
  try {
    const response = await axiosInstance.post(`/menus/create-menu-items`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const deleteMenuItem = async (userData) => {
  try {
    const response = await axiosInstance.post(`/menus/delete-menu-items`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getParentMenus = async () => {
  try {
    const response = await axiosInstance.get(`/menus/menu-dropdown`);
    return response;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getEmployeeList = async () => {
  try {
    const response = await axiosInstance.get(`/people-finder/employees`);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const fetchReportingDetails = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/people-finder/search`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const addPanels = async (userData) => {
  try {
    const response = await axiosInstance.post(`/committee_panel/create_panel`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAllPanels = async () => {
  try {
    console.log("calling");
    const response = await axiosInstance.get(`/committee_panel/get_all_panels`);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const addPanelMember = async (userData) => {
  try {
    const response = await axiosInstance.post(`/committee_panel/add_member`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const fetchPanelMembers = async (params = {}) => {
  try {
    // Keeps logic for dynamic path parameter
    const url = `/committee_panel/get_members_by_panel/${params.panel_id || ''}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const removeMember = async (userData) => {
  try {
    const response = await axiosInstance.post(`/committee_panel/remove_member`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const updatePanel = async (userData) => {
  try {
    const response = await axiosInstance.post(`/committee_panel/update_panel`, userData);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAdminAccess = async () => {
  try {
    console.log("calling");
    const response = await axiosInstance.get(`/committee_panel/check_committee_admin_access`);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const fetchSkillMatrix = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/skill-finder/fetch-skills-by-empid-or-by-skillname`, {
      params: {
        emp_id: params.emp_id || "",
        skill_name: params.skill_name || ""
      }
    });
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getAllApplication = async () => {
  try {
    const response = await axiosInstance.get(`/menus/get-all-applications`);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};


export const getAllSkills = async () => {
  try {
    const response = await axiosInstance.get(`/skill-finder/skill-master-list`);
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getRolesForApplication = async (params = {}) => {
  try {
    
    const response = await axiosInstance.get(`/menus/get-all-roles-by-application-id`, {
      params: {
         application_id: params  || ""
      }
    });
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    throw error.response?.data || { message: "Network error" };
  }
};